import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import TimelineIcon from '@mui/icons-material/Timeline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BusinessIcon from '@mui/icons-material/Business';

export default function BidPipeline({ bids, title = "Bid Pipeline" }) {
    const navigate = useNavigate();

    if (!bids || bids.length === 0) {
        return (
            <div className="dashboard_section">
                <div className="section_header">
                    <h3><TimelineIcon /> {title}</h3>
                </div>
                <div className="empty_state small">
                    <HourglassEmptyIcon className="empty_icon" />
                    <p>No pending bids. Find projects to bid on!</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard_section">
            <div className="section_header">
                <h3><TimelineIcon /> {title}</h3>
            </div>
            <div className="bid_pipeline_list">
                {bids.map((project) => (
                    <div 
                        key={project.id} 
                        className="bid_pipeline_item"
                        onClick={() => navigate(`/project-details/${project.id}/true?pending=true`)}
                    >
                        <div className="bid_pipeline_status">
                            <span className="status_indicator pending"></span>
                        </div>
                        <div className="bid_pipeline_content">
                            <h4 className="bid_project_name">
                                {project.project_name.length > 40 
                                    ? `${project.project_name.slice(0, 40)}...` 
                                    : project.project_name}
                            </h4>
                            <div className="bid_pipeline_meta">
                                {project.user && (
                                    <span className="meta_item">
                                        <BusinessIcon />
                                        {project.user.company_name || `${project.user.fname} ${project.user.lname}`}
                                    </span>
                                )}
                                {project.my_bid?.price && (
                                    <span className="meta_item">
                                        <AttachMoneyIcon />
                                        ${Number(project.my_bid.price).toLocaleString()}
                                    </span>
                                )}
                            </div>
                            <span className="bid_submitted_date">
                                Submitted {moment(project.my_bid?.created_at || project.created_at).fromNow()}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
